import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module
import { formatNumber, parseDate } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table
export type OpenFigi = {
  id: number;
  unique_id: string | null;
  figi: string | null;
  name: string | null;
  ticker: string | null;
  exchange_code: string | null;
  composite: string | null;
  security_type: string | null;
  security_description: string | null;
  market_sector: string | null;
  figi_share_class: string | null;
  fut_opt: string | null;
  security_type2: string | null;
  is_perpetual: boolean | null;
  maturity: string | null;
  coupon: number | null;
  created_at: string;
  updated_at: string;
};

// Definition of the columns
export const open_figis_columns: ColumnDef<OpenFigi>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "figi",
    header: "FIGI",
    cell: ({ row }) => row.getValue("figi") ?? "",
  },
  {
    accessorKey: "unique_id",
    header: "Unique ID",
    cell: ({ row }) => row.getValue("unique_id") ?? "",
  },
  {
    accessorKey: "name",
    header: "Name",
    cell: ({ row }) => row.getValue("name") ?? "",
  },
  {
    accessorKey: "ticker",
    header: "Ticker",
    cell: ({ row }) => row.getValue("ticker") ?? "",
  },
  {
    accessorKey: "exchange_code",
    header: "Exchange Code",
    cell: ({ row }) => row.getValue("exchange_code") ?? "",
  },
  {
    accessorKey: "composite",
    header: "Composite",
    cell: ({ row }) => row.getValue("composite") ?? "",
  },
  {
    accessorKey: "security_type",
    header: "Security Type",
    cell: ({ row }) => row.getValue("security_type") ?? "",
  },
  {
    accessorKey: "security_description",
    header: "Security Description",
    cell: ({ row }) => row.getValue("security_description") ?? "",
  },
  {
    accessorKey: "market_sector",
    header: "Market Sector",
    cell: ({ row }) => row.getValue("market_sector") ?? "",
  },
  {
    accessorKey: "figi_share_class",
    header: "FIGI Share Class",
    cell: ({ row }) => row.getValue("figi_share_class") ?? "",
  },
  {
    accessorKey: "fut_opt",
    header: "Fut/Opt",
    cell: ({ row }) => row.getValue("fut_opt") ?? "",
  },
  {
    accessorKey: "security_type2",
    header: "Security Type 2",
    cell: ({ row }) => row.getValue("security_type2") ?? "",
  },
  {
    accessorKey: "is_perpetual",
    header: "Is Perpetual",
    cell: ({ row }) =>
      row.getValue("is_perpetual")
        ? "Yes"
        : row.getValue("is_perpetual") === false
          ? "No"
          : "",
  },
  {
    accessorKey: "maturity",
    header: "Maturity",
    cell: ({ row }) => {
      const value = row.getValue<string | null>("maturity");
      return value ? parseDate(value) : "";
    },
  },
  {
    accessorKey: "coupon",
    header: "Coupon",
    cell: ({ row }) => {
      const value = row.getValue<number | null>("coupon");
      return value != null ? formatNumber(value) : "";
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue<string>("created_at")),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => parseDate(row.getValue<string>("updated_at")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      const id = row.getValue("id");
      return (
        <div className="flex justify-end space-x-2">
          <Link
            href={toWorkspacePath(
              `/admin/qtl - referential/strategies?open_figi_id=${id}`,
            )}
            className="text-xs"
            underline="hover"
          >
            Strategies
          </Link>
          <Link
            href={`${window.location.pathname}/${id}`}
            className="text-xs"
            underline="hover"
          >
            View
          </Link>
        </div>
      );
    },
  },
];
